var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[_c('div',{attrs:{"id":"mp"}},[_c('dashboard-navbar'),_c('router-view'),_c('content-footer')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }